import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './SignupPromptModal.css';

function SignupPromptModal({ isOpen, onClose }) {
    const { signInWithGoogle } = useAuth();

    if (!isOpen) return null;

    const handleSignup = async () => {
        try {
            await signInWithGoogle();
            onClose();
        } catch (error) {
            console.error('Signup error:', error);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <div className="modal-icon">🎁</div>
                <h2 className="modal-title">Out of Points!</h2>
                <p className="modal-message">
                    Sign up now to get <strong>200 bonus points</strong> plus <strong>20 points daily</strong>!
                </p>
                <div className="modal-actions">
                    <button className="btn-signup" onClick={handleSignup}>
                        Sign Up with Google
                    </button>
                    <button className="btn-later" onClick={onClose}>
                        Maybe Later
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SignupPromptModal;
